export default __webpack_public_path__ + "static/media/1.0e128f12.png";